import { FormWithControlledNavigation as CosagoFormWithControlledNavigation } from '@sravni/cosago-react-library/lib/components';
import cn from 'classnames';
import type { PropsWithChildren } from 'react';

import type { FormWithControlledNavigationProps } from '@sravni/cosago-react-library/dist/types/components/widgets/FormWithControlledNavigation/interface';

import styles from './FormWithControlledNavigation.module.scss';

export const FormWithControlledNavigation: FC<PropsWithChildren<FormWithControlledNavigationProps>> = ({
  className,
  children,
  ...props
}) => (
  <CosagoFormWithControlledNavigation
    className={cn(styles.cosagoFormWithControlledNavigation, className)}
    {...props}
  >
    {children}
  </CosagoFormWithControlledNavigation>
);
